import { cn } from "@/lib/utils";
import React from "react";
import { DataTableSearch } from "./data-table-search";
import {
  DataTableFilters,
  DataTableFiltersFormProviderConditional,
} from "./data-table-filters";

import { Useable, useTableSearch } from "../data-table-context";
import { ActionsType } from "./data-table-actions";

export type DataTableButtonsProps = React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLDivElement>,
  HTMLDivElement
> & {
  left?: React.FC;
  right?: React.FC;
  search?: React.ReactNode;
  filter?: React.ReactNode;
  filters?: React.FC;
  combineForms?: boolean;
  allFiltersAfterInline?: boolean;
  filtersInline?: React.FC;
  sort?: React.ReactNode;
  actions?: Useable<ActionsType>;
};

export const DataTableButtons = React.forwardRef<
  HTMLDivElement,
  DataTableButtonsProps
>(
  (
    {
      children, //
      className,
      search,
      filter,
      filters,
      allFiltersAfterInline = false,
      filtersInline: FiltersInline,
      sort,
      left: Left,
      right: Right,
      actions,
      combineForms,
      ...props
    },
    ref,
  ) => {
    const { searchField } = useTableSearch();
    return (
      <div
        data-component="data-table-buttons"
        {...props}
        ref={ref}
        className={cn(className, "flex gap-2 flex-wrap")}
      >
        {(Left && <Left />) ?? children}
        {search ?? (searchField ? <DataTableSearch /> : undefined)}
        <DataTableFiltersFormProviderConditional omit={!combineForms}>
          {!allFiltersAfterInline &&
            (filter ??
              (filters ? (
                <DataTableFilters omit={combineForms} filters={filters} />
              ) : undefined))}
          {!!FiltersInline && (
            <DataTableFiltersFormProviderConditional omit={combineForms}>
              <div
                data-component="data-table-filters-inline"
                className="flex items-center gap-2"
                tabIndex={0}
                onKeyDown={(ev) => {
                  ev.stopPropagation();
                }}
              >
                <FiltersInline />
              </div>
            </DataTableFiltersFormProviderConditional>
          )}
          {allFiltersAfterInline &&
            (filter ??
              (filters ? (
                <DataTableFilters omit={combineForms} filters={filters} />
              ) : undefined))}
        </DataTableFiltersFormProviderConditional>
        {sort}
        {Right && <Right />}
      </div>
    );
  },
);
